import * as React from 'react';

import { ToString } from '../../lib/utils';

class Place extends React.Component<SearchInput.IPlaceProps> {
  render() {
    const { place, className } = this.props;

    return (
      <div className={`search-result px-2 py-1 c-pointer place ${ToString(className)}`} onClick={this._onClick}>
        {this.props.getLabel(place)}
      </div>
    );
  }

  _onClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();

    return this.props.onClick && this.props.onClick(this.props.place);
  };
}

export default Place;
